import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders } from "../../utils/axios";

export const getInquiryList = createAsyncThunk(
  "inquiry/getInquiryList",
  async ({search,page,limit},{ rejectWithValue }) => {
    try {
      const response = await Axios.get(`/api/bank/inquiries/list?limit=${limit || 10}&page=${page || 1}&search=${search || ""}`, authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

const inquirySlice = createSlice({
  name: "inquiry",
  initialState: {
    isLoading: false,
    error: null,
    inquiryList: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET Inquiry List
      .addCase(getInquiryList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.inquiryList = action.payload;
      });
  },
});

export default inquirySlice.reducer;
